import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { id: "print-ticket" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = {
  key: 0,
  id: "logo"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { id: "name" }
const _hoisted_6 = {
  key: 1,
  id: "desc"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1)
const _hoisted_8 = { id: "ticket" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "separator" }, null, -1)
const _hoisted_10 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.activeActivity.logo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.activityLogo,
              style: {"max-width":"50mm"},
              alt: ""
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.activeActivity.name), 1),
      (_ctx.activeActivity.slogan)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.activeActivity.slogan), 1))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createElementVNode("table", _hoisted_8, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("date")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.selected.createdAt, _ctx.$t("format.ticketDate"))), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("document.number")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.selected.number), 1)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("document.type")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$tm("document.types")[_ctx.selected.type]), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("table", _hoisted_10, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.product")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.price")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.initial")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.quantity")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.final")), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.expiredAt")), 1)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movements, (mvt, index) => {
          return (_openBlock(), _createElementBlock("tr", { key: index }, [
            _createElementVNode("td", null, _toDisplayString(mvt.product.name), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_NumberFormatter, {
                value: mvt.price
              }, null, 8, ["value"]),
              _createTextVNode(" " + _toDisplayString(_ctx.activeActivity.currencySymbol), 1)
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_NumberFormatter, {
                value: mvt.qStock - mvt.quantity
              }, null, 8, ["value"])
            ]),
            _createElementVNode("td", null, [
              _createTextVNode(_toDisplayString(mvt.motif > 0 ? "+" : "") + " ", 1),
              _createVNode(_component_NumberFormatter, {
                value: mvt.quantity
              }, null, 8, ["value"])
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_NumberFormatter, {
                value: mvt.qStock
              }, null, 8, ["value"])
            ]),
            _createElementVNode("td", null, _toDisplayString(mvt.stock.expiredAt && _ctx.$d(mvt.stock.expiredAt as any)), 1)
          ]))
        }), 128))
      ])
    ])
  ], 512)), [
    [_vShow, false]
  ])
}